import { useEffect } from 'react';
import { fetchSubscriptions, fetchSubscriptionStatus } from 'State/Subscriptions';
import { useStore } from './useStore';

export const useSubscription = () => {
  const { isAuthenticated } = useStore('user');
  const { isPlanPayment } = useStore('purchaseMode');
  const subscription = useStore('subscription');
  useEffect(() => {
    if (isAuthenticated && !subscription.isSuccess && !subscription.isFetching) {
      fetchSubscriptions();
      if (isPlanPayment) {
        fetchSubscriptionStatus();
      }
    }
  }, [isPlanPayment, isAuthenticated, subscription]);
  return subscription;
};
